import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
// import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';
import { FormHelperText, TextField, FormControl } from '@mui/material';



// Knowledge Bank page to add new Knowledge Bank page

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        backgroundColor: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};



export default class KnowledgeAddNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            KnowledgeTitle: '',
            KnowledgePDF: null,
            KnowledgeDescription: '',
            errorMessage: [],
            modalIsOpenSuccess: false,
            showErrorMessage: false,
            usernameAvailable: true,
            knowledgeBankData: [],
            loader: false,
            snackbarActive: false,
            snackbarMessage: ''
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
            modalIsOpen: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }


    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',
            title: '',
            pdf: '',
            description: '',
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }


    componentDidMount() {
        this.fecthAllKnowledgeBank();
    }

    fecthAllKnowledgeBank = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/knowledge-bank/', { // Change to Knowledge Bank
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    knowledgeBankData: data
                })
                // console.log(data)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    AddingKnowledgeBank = () => {
        const { KnowledgeTitle: title, KnowledgePDF: pdf, KnowledgeDescription: description } = this.state;

        // Retrieve token from localStorage
        let tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;

        // Create FormData object to handle file upload
        const formData = new FormData();
        formData.append('title', title);
        formData.append('pdf', pdf); // File
        formData.append('description', description);

        // Define headers for the request
        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        // Send data to the server using fetch and FormData
        fetch('/cloud/knowledge-bank/', {
            method: "POST",
            headers,  // Do not set 'Content-Type' for FormData, browser handles it
            body: formData,  // Send the form data including the file
        })
            .then(response => {
                if (response.status === 403) {
                    // Handle session timeout by redirecting to session timeout page
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout';
                } else {
                    return response.json();  // Parse the response as JSON
                }
            })
            .then(data => {
                if (data.message !== "failure") {
                    // Successfully added data, close modal and show success message
                    this.setState({
                        modalIsOpen: false,  // Close the modal immediately
                        modalIsOpenSuccess: true,  // Show success message
                        loader: false,  // Hide loading spinner
                        KnowledgeTitle: '',  // Clear the title field
                        KnowledgePDF: null,  // Reset the file field
                        KnowledgeDescription: '',  // Clear the description field
                        showErrorMessage: false,  // Hide error message
                    });

                    // Fetch updated list of KnowledgeBank's or any other data
                    this.fecthAllKnowledgeBank();
                } else {
                    // Failure: Show error message
                    this.setState({
                        loader: false,
                        snackbarActive: true,  // Activate the snackbar
                        snackbarMessage: `${Object.keys(data.data)[0]}: ${data.data[Object.keys(data.data)[0]]}`,
                    });
                }
            })
            .catch(err => {
                console.log(err);  // Log any error that occurs during the fetch request
            });
    };






    AddingAnotherKnowledgeBank = () => {
        const { KnowledgeTitle: title, KnowledgePDF: pdf, KnowledgeDescription: description } = this.state;

        // Retrieve token
        let tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;

        // Create FormData object
        const formData = new FormData();
        formData.append('title', title);
        formData.append('pdf', pdf); // Add the file object
        formData.append('description', description);

        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        // Fetch request
        fetch('/cloud/knowledge-bank/', {
            method: "POST",
            headers, // Note: Do not add 'Content-Type' when using FormData; the browser sets it automatically
            body: formData,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Handle session timeout
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout';
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                if (data.message !== "failure") {
                    this.setState({
                        modalIsOpen: false,
                        addAnotherSuccess: true,
                        knowledgeBankData: data
                    }, () => {
                        setTimeout(() => {
                            this.setState({ addAnotherSuccess: false });
                        }, 3000);

                        this.setState({
                            modalIsOpen: true,
                            KnowledgeTitle: '',
                            KnowledgePDF: null, // Reset to null instead of an empty string
                            KnowledgeDescription: '',
                            showErrorMessage: false,
                            loader: false,
                        }, () => this.fecthAllKnowledgeBank());
                    });
                } else {
                    alert('Knowledge Bank with same details already added');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/distributor/Knowledge';
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };




    AddKnowledgeBank = () => {
        this.setState({
            showErrorMessage: true
        }, () => {
            this.fetchError((e) => {
                if (e === 'NoError') {
                    this.setState({
                        loader: true
                    }, () => this.AddingKnowledgeBank())
                }
            })
        })
    }


    AddAnotherKnowledgeBank = () => {
        this.setState({
            showErrorMessage: true
        }, () => {
            this.fetchError((e) => {
                if (e === 'NoError') {
                    this.setState({
                        loader: true
                    }, () => this.AddingAnotherKnowledgeBank())
                }
            })
        })
    }


    checkKnowledgeBankTitle = (e) => {
        let data = '';
        this.state.knowledgeBankData.forEach((e) => {
            console.log(e.title);
            if (e.title === this.state.KnowledgeTitle) {
                data = 'title exist';
            }
        })
        if (data === 'title exist') {
            this.setState({
                usernameAvailable: false
            })
        }
    }

    fetchError = (noError) => {
        var totalError = 3;

        if (ErrorText('notEmpty', this.state.KnowledgeTitle) === 'No Error') {
            totalError = totalError - 1;
        }

        if (ErrorText('notEmpty', this.state.KnowledgeDescription) === 'No Error') {
            totalError = totalError - 1;
        }

        // Check if the uploaded PDF file is valid
        if (this.state.KnowledgePDF) {
            // Pass file to the 'isPDF' error check
            const fileError = ErrorText('isPDF', this.state.KnowledgePDF);
            if (fileError === 'No Error') {
                totalError = totalError - 1;
            } else {
                // Optionally, you can show a message or handle the invalid file error here
                console.log(fileError); // Log the error message for invalid file
            }
        }


        if (totalError === 0) {
            noError('NoError');
        }
    }

    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event
        }, () => {
            if (true) {
                this.checkKnowledgeBankTitle()
            }
        });
    }
    // handleFileUpload(event) {
    //     const file = event.target.files[0];
    //     if (file && file.type === '.pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    //         this.setState({ KnowledgePDF: file, showErrorMessage: false });
    //     } else {
    //         this.setState({ KnowledgePDF: null, showErrorMessage: true });
    //         alert('Please upload a valid PDF file.');
    //     }
    // }


    handleFileUpload = (event) => {
        const file = event.target.files[0];

        // Validate if the uploaded file is valid PDF or supported file type
        if (file) {
            const fileError = ErrorText('isPDF', file);
            if (fileError === 'No Error') {
                this.setState({ KnowledgePDF: file, showErrorMessage: false });
                // console.log("Valid file uploaded.");
            } else {
                this.setState({ KnowledgePDF: null, showErrorMessage: true });
                // console.log(fileError);
            }
        }
    };

    render() {
        return (
            <React.Fragment>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas fa-timess fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Add Knowledge Bank</h3>
                    <div className="row">
                        {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
                            Successfully added the Knowledge Bank.
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            </button>
                        </div> : null}
                    </div>
                    <div className="row">
                        <div className="col-6" >
                            <TextField
                                label="Title"
                                variant="standard"
                                fullWidth
                                value={this.state.KnowledgeTitle}
                                onChange={(e) => this.handleChangeInputBox('KnowledgeTitle', e.target.value)}
                                inputProps={{ maxLength: 30 }}
                                error={
                                    this.state.showErrorMessage &&
                                    ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error'
                                }
                                helperText={
                                    this.state.showErrorMessage &&
                                        ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error'
                                        ? 'Please enter the Knowledge Bank Title'
                                        : ''
                                }
                                sx={{ mt: '3.9%' }}
                            />
                        </div>

                        <div className="col-6 mx-0 px-0 ">

                            {/* <input
                                type="file"
                                // accept="application/pdf"
                                accept=".pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                onChange={(event) => this.handleFileUpload(event)}
                                style={{ marginTop: '10px' }}
                                // error={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Knowledge Bank Title' : ''}
                                placeholder="Title"
                            /> */}

                            <FormControl
                                error={
                                    this.state.showErrorMessage &&
                                    ErrorText("notEmpty", this.state.KnowledgeTitle) !== "No Error"
                                }
                                fullWidth
                                sx={{ mt: '2.3%' }}
                            >
                                <input
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    onChange={(event) => {
                                        const file = event.target.files[0];
                                        if (file) {
                                            const allowedTypes = [
                                                "application/pdf",
                                                "application/msword",
                                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                            ];

                                            if (!allowedTypes.includes(file.type)) {
                                                this.setState({
                                                    fileErrorText: "Only PDF, DOC, or DOCX files are allowed.",
                                                    showErrorMessage: true,
                                                });
                                                event.target.value = ""; // clear input
                                                return;
                                            }

                                            this.setState({
                                                fileErrorText: "",
                                                showErrorMessage: false,
                                            });

                                            this.handleFileUpload(event);
                                        }
                                    }}
                                />
                                <FormHelperText>
                                    {this.state.showErrorMessage &&
                                        ErrorText("notEmpty", this.state.KnowledgeTitle) !== "No Error"
                                        ? "Please add valid PDF, DOC, or DOCX files"
                                        : this.state.fileErrorText}
                                </FormHelperText>
                            </FormControl>

                        </div>
                        <div className="col-6 ">
                            <TextField
                                label="Description"
                                variant="standard"
                                fullWidth
                                multiline
                                value={this.state.KnowledgeDescription}
                                onChange={(e) => this.handleChangeInputBox('KnowledgeDescription', e.target.value)}
                                inputProps={{ maxLength: 255 }}
                                error={
                                    this.state.showErrorMessage &&
                                    ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error'
                                }
                                helperText={
                                    this.state.showErrorMessage &&
                                        ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error'
                                        ? 'Please enter Description'
                                        : ''
                                }
                                sx={{ mt: '3.9%' }} // Top margin 1%
                            />
                        </div>
                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Cancel</div>
                        <div className="btn btn-new-orange" style={{ marginRight: '15px' }} onClick={this.AddAnotherKnowledgeBank.bind(this)}>
                            Add Another
                        </div>
                        <i className="fa fa-star-christmas fa-spin"></i>
                        <div className="btn btn-new-green " onClick={this.AddKnowledgeBank.bind(this)}>Add</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">Knowledge Bank Added Successfully</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
